import { partCreateWizardStepFields } from './create-form.js';
import { getVisiblePartCreateSteps, PART_CREATE_COSTING_STEP, PART_CREATE_IDENTITY_STEP, PART_CREATE_LOCATION_STEP, PART_CREATE_PRODUCT_STEP, PART_CREATE_TYPE_STEP, PART_CREATE_UOM_STEP, PART_CREATE_VENDOR_STEP, } from './create-wizard-navigation.js';
export const PART_CREATE_BASICS_PHASE = 'basics';
export const PART_CREATE_COMMERCIAL_PHASE = 'commercial';
export const PART_CREATE_STOCK_PHASE = 'stock';
/** Each phase holds a section no part type hides, so no phase vanishes from the stepper mid-flow. */
const PHASE_DEFINITIONS = [
    {
        id: PART_CREATE_BASICS_PHASE,
        title: 'Basics',
        subtitle: 'Number, type, UOM',
        steps: [PART_CREATE_IDENTITY_STEP, PART_CREATE_TYPE_STEP, PART_CREATE_UOM_STEP],
    },
    {
        id: PART_CREATE_COMMERCIAL_PHASE,
        title: 'Commercial',
        subtitle: 'Product and vendor',
        steps: [PART_CREATE_PRODUCT_STEP, PART_CREATE_VENDOR_STEP],
    },
    {
        id: PART_CREATE_STOCK_PHASE,
        title: 'Stock & Cost',
        subtitle: 'Warehouse and cost',
        steps: [PART_CREATE_LOCATION_STEP, PART_CREATE_COSTING_STEP],
    },
];
export function getVisiblePartCreatePhases(typeId) {
    const visibleSteps = new Set(getVisiblePartCreateSteps(typeId));
    return PHASE_DEFINITIONS.map((phase) => ({
        id: phase.id,
        title: phase.title,
        subtitle: phase.subtitle,
        steps: phase.steps.filter((step) => visibleSteps.has(step)),
    }));
}
export function getPartCreatePhaseFields(phaseId, typeId) {
    const phase = getVisiblePartCreatePhases(typeId).find((candidate) => candidate.id === phaseId);
    if (!phase)
        return [];
    return phase.steps.flatMap((step) => partCreateWizardStepFields[step] ?? []);
}
//# sourceMappingURL=create-wizard-phases.js.map